import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { IconButton, TextField } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import "./Section.css";
import ClearIcon from "@mui/icons-material/Clear";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { toast } from "react-toastify";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";

export default function Platforms({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [slides, setSlides] = useState([]);
  const [images, setImages] = useState([]);

  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const hiddenFileInput2 = useRef();
  const hiddenFileInput3 = useRef();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  const formData = new FormData();

  useEffect(() => {
    let docs = langs.map((item) => ({
      metaParagraph: "",
      btnOneText: "",
      btnOneLink: "",
      btnTwoText: "",
      btnTwoLink: "",
      middleText: "",
      language: item.attributes.language,
    }));
    setData(docs);
    let slidesDocs = langs.map((item) => []);
    setSlides(slidesDocs);
    let imagesDocs = langs.map((item) => ({
      metaImg: "",
      middleBG: "",
      language: item.attributes.language,
    }));
    setImages(imagesDocs);
    async function getData() {
      await fetch(`${API}/platform`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.platformData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                metaParagraph: apiItem.metaParagraph || localItem.metaParagraph,
                btnOneText: apiItem.btnOneText || localItem.btnOneText,
                btnOneLink: apiItem.btnOneLink || localItem.btnOneLink,
                btnTwoText: apiItem.btnTwoText || localItem.btnTwoText,
                btnTwoLink: apiItem.btnTwoLink || localItem.btnTwoLink,
                slideBTNText: apiItem.slideBTNText || localItem.slideBTNText,
                slideBTNLink: apiItem.slideBTNLink || localItem.slideBTNLink,
                middleText: apiItem.middleText || localItem.middleText,
              };
            } else {
              return localItem;
            }
          });
        });

        const updatedSlides = apiData.map((item) => item.slides || []);

        setSlides(updatedSlides);

        const apiImages = response.data?.attributes?.images || [];

        setImages((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiImages.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                middleBG: apiItem.middleBG || localItem.middleBG,
                metaImg: apiItem.metaImg || localItem.metaImg,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    let updatedData = [...data];

    slides.forEach((slideArray, index) => {
      if (updatedData[index]) {
        updatedData[index].slides = slideArray;
      } else {
        updatedData[index] = { slides: slideArray };
      }
    });

    fetch(`${API}/platform`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { platformData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
        setData(updatedData);
      } else {
        setFail(true);
      }
    });
  };

  const handleRemoveSlide = (index, idx) => {
    let updatedSlides = [...slides];

    updatedSlides[index] = updatedSlides[index].filter((_, i) => i !== idx);

    setSlides(updatedSlides);
  };

  const handleSlidesInputChange = (e, index, idx) => {
    const { name, value } = e.target;

    let updatedSlided = [...slides];
    updatedSlided[index][idx] = {
      ...updatedSlided[index][idx],
      [name]: value,
    };

    setSlides(updatedSlided);
  };

  const handleImageChange = (e, index, type) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedImages = [...images];

        updatedImages[index] = { ...updatedImages[index], [type]: iconURL };

        fetch(`${API}/platform`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { images: updatedImages },
          }),
        }).then((res) => {
          if (res.ok) {
            setImages(updatedImages);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Platforms Page Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    className="flex gap-3 flex-wrap"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TextField
                      sx={{ width: 300 }}
                      label="Button 1 Text"
                      value={data[index]?.btnOneText || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, btnOneText: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <TextField
                      sx={{ width: 300 }}
                      label="Button 1 Link"
                      value={data[index]?.btnOneLink || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, btnOneLink: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  <div
                    className="flex gap-3 flex-wrap mt-6"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <TextField
                      sx={{ width: 300 }}
                      label="Button 2 Text"
                      value={data[index]?.btnTwoText || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, btnTwoText: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <TextField
                      sx={{ width: 300 }}
                      label="Button 2 Link"
                      value={data[index]?.btnTwoLink || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, btnTwoLink: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  <div className="mt-5">
                    <TextField
                      sx={{ width: 550 }}
                      label="Middle Section Text"
                      value={data[index]?.middleText || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return { ...item, middleText: e.target.value };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                  </div>

                  <div>
                    <p style={{ fontSize: 15, marginTop: 30 }}>
                      MetaTrader Section Paragraph
                    </p>

                    <div style={{ margin: "15px 0" }}>
                      <TextEditor
                        value={data[index]?.metaParagraph || ""}
                        onChange={(v) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return {
                                  ...item,
                                  metaParagraph: v,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                    </div>
                  </div>

                  <div className="divider"></div>

                  <div className="mt-6">
                    <h3 className="text-[1.5rem] mb-3">
                      What you can trade cards
                    </h3>

                    {/* <TextField
                      label="Button Text"
                      sx={{ width: 300, margin: 1 }}
                      value={data[index]?.slideBTNText || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                slideBTNText: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    />
                    <TextField
                      label="Button Link"
                      sx={{ width: 300, margin: 1 }}
                      value={data[index]?.slideBTNLink || ""}
                      onChange={(e) => {
                        setData([
                          ...data.map((item, idx) => {
                            if (idx === index) {
                              return {
                                ...item,
                                slideBTNLink: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                      }}
                    /> */}

                    <div className="mt-5 grid lg:grid-cols-2 grid-cols-1 ">
                      {slides[index]?.map((item, idx) => (
                        <div key={idx} className=" mt-4">
                          <div
                            className="flex w-9/12"
                            style={{ justifyContent: "space-between" }}
                          >
                            <h3>Card {idx + 1}</h3>

                            <IconButton
                              onClick={() => handleRemoveSlide(index, idx)}
                            >
                              <ClearIcon sx={{ color: "red" }} />
                            </IconButton>
                          </div>
                          <TextField
                            sx={{ width: 350, mt: 1 }}
                            label="Title"
                            variant="outlined"
                            size="small"
                            name="title"
                            value={slides[index][idx]?.title || ""}
                            onChange={(e) =>
                              handleSlidesInputChange(e, index, idx)
                            }
                          />

                          <TextField
                            sx={{ width: 350, mt: 2 }}
                            label="Description"
                            variant="outlined"
                            size="small"
                            name="desc"
                            multiline
                            rows={3}
                            value={slides[index][idx]?.desc || ""}
                            onChange={(e) =>
                              handleSlidesInputChange(e, index, idx)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    <div
                      className="w-3/12 h-9 min-w-[200px] rounded-sm flex bg-green-600 text-white mt-3 cursor-pointer hover:bg-green-700 transition-all delay-100"
                      onClick={() => {
                        let slidesDocs = [...slides];
                        slidesDocs[index].push({
                          title: "",
                          desc: "",
                        });
                        setSlides(slidesDocs);
                      }}
                    >
                      Add a New Card
                    </div>
                  </div>

                  {user.perms[9].edit && (
                    <div
                      className="submitBTN"
                      onClick={() => submitData(item, index)}
                    >
                      Save Changes
                    </div>
                  )}

                  <div className="divider"></div>
                  {user.perms[9].edit && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: 25,
                        flexWrap: "wrap",
                      }}
                    >
                      <div className="w-4/12">
                        <h3 className="ml-3">Middle Background Image</h3>

                        <div
                          className="group relative w-full h-[220px] mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                          onClick={() => hiddenFileInput2.current.click()}
                        >
                          <img
                            style={{
                              width: "100%",
                              aspectRatio: 1,
                              objectFit: "cover",
                              transition: "0.2s",
                            }}
                            src={
                              images[index]?.middleBG
                                ? SERVER_DOMAIN + images[index]?.middleBG
                                : require("../assets/placeholder-image.png")
                            }
                          />

                          <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                            <CameraAltIcon
                              style={{ fontSize: 45 }}
                              className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            />
                          </div>

                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleImageChange(e, index, "middleBG")
                            }
                            ref={hiddenFileInput2}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>

                      <div className="w-3/12">
                        <h3 className="ml-3">MetaTrader Image</h3>

                        <div
                          className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                          onClick={() => hiddenFileInput3.current.click()}
                        >
                          <img
                            style={{
                              width: "100%",
                              aspectRatio: 1,
                              objectFit: "cover",
                              transition: "0.2s",
                            }}
                            src={
                              images[index]?.metaImg
                                ? SERVER_DOMAIN + images[index]?.metaImg
                                : require("../assets/placeholder-image.png")
                            }
                          />

                          <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                            <CameraAltIcon
                              style={{ fontSize: 45 }}
                              className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                            />
                          </div>

                          <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={(e) =>
                              handleImageChange(e, index, "metaImg")
                            }
                            ref={hiddenFileInput3}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
